<div class="remote-select">
  <div class="input-group">
      <input #select (click)="onClick()" (blur)="onExit($event)" (change)="onChange($event)" [(ngModel)]="inputValue" (keyup)="onChange($event)" type="search" class="form-control" placeholder="" aria-label="Username" aria-describedby="basic-addon1">
      <div *ngIf="isLoading">{{'sale4all.label.loading' | translate}}</div>
      <div *ngIf="expanded&&(!isLoading)" id="options">
        <option *ngFor="let opt of dataList" (click)="selectValue(opt)" [value]="opt">{{opt.label}}</option>
      </div>
  </div>
</div>
